import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import qs from 'qs';

// The signed-in person's own pages (the account menu's Profile and Change
// password), as a side menu in the same look as the settings menu
// (pages/preferences/settings-sidebar.js, styles/secondary-nav.scss).
@inject('viewStore', 'userStore')
@observer
class AccountSidebar extends Component {
  @observable isOpen = false; // the menu on phones

  render() {
    const { viewStore, userStore } = this.props;
    const me = viewStore.currentUser;
    const shown = userStore.user && userStore.user.object;
    const onProfile = viewStore.currentView === 'Pages.Users.Show' && shown && me && shown.id === me.id;
    const onPassword = viewStore.currentView === 'Pages.Users.ChangePassword';
    const profileHref = me ? `/dashboard/users/${me.id}/show?${qs.stringify(viewStore.userShowSearch, { encode: false })}` : '#';
    return (
      <nav className="sidebar-mobile account-sidebar" aria-label="Your account">
        <div className="mobile-dropdown">
          <div className="setting-icon">
            <button
              type="button"
              className="account-sidebar__toggle"
              aria-expanded={this.isOpen}
              aria-controls="account-sidebar-links"
              onClick={() => { this.isOpen = !this.isOpen; }}
            >
              <img src="/settings.svg" alt="Your account" />
            </button>
          </div>
          <div id="account-sidebar-links" className={this.isOpen ? 'ssidebar-wrap' : 'ssidebar-wrap ssidebar-wrap-hide'}>
            <ul className="list-unstyled setting-list">
              <li className={onProfile ? 'active' : ''}>
                <a href={profileHref} aria-current={onProfile ? 'page' : undefined}>Profile</a>
              </li>
              <li className={onPassword ? 'active' : ''}>
                <a href="/dashboard/users/change-password" aria-current={onPassword ? 'page' : undefined}>Change password</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default AccountSidebar;
